import { useState } from "react";
import dayjs from "dayjs";
import Constants from "common/constant";
import { UserAvatar } from "common/elements";
import { ChatImageViewer } from "features/shared";
import { AIChatMessage as AIChatMessageType } from "features/player/types";

interface AIChatMessageProps {
  messages: AIChatMessageType[];
  childIcon?: string;
}

// 日時フォーマット
const formatDate = (dateString: string) => {
  return dayjs(dateString).format("YYYY-MM-DD HH:mm");
};

export const AIChatMessage = ({ messages, childIcon }: AIChatMessageProps) => {
  const [previewUrl, setPreviewUrl] = useState<string>();

  return (
    <div className="flex-col-el gap-3">
      {messages.map((message) => {
        const isUser = message.role === "user";

        return (
          <div
            key={message.id}
            className={`flex ${isUser ? "justify-end" : "justify-start"} gap-2`}
          >
            {/* AI（アシスタント）のメッセージ - 左側 */}
            {!isUser && (
              <>
                {/* AIアイコン */}
                <div className="w-12 h-12 shrink-0">
                  <UserAvatar
                    icon={`${Constants.assetHost}/assets/images/little_pal.png`}
                    size={48}
                  />
                </div>

                {/* メッセージ本体 */}
                <div className="max-w-[70%] py-3 px-4 bg-gray-20 text-textcolor-black rounded-[16px] rounded-bl-[4px] shadow-sm">
                  {message.content && (
                    <div className="text-[21px] leading-[1.6] mb-2 whitespace-pre-wrap">
                      {message.content}
                    </div>
                  )}
                  <div className="text-[16px] text-gray2-100">{formatDate(message.created_at)}</div>
                </div>
              </>
            )}

            {/* ユーザー（子供）のメッセージ - 右側 */}
            {isUser && (
              <>
                {/* メッセージ本体 */}
                <div className="max-w-[70%] py-3 px-4 bg-white/80 text-textcolor-black rounded-[16px] rounded-tr-[4px] shadow-sm">
                  {/* 画像表示（複数対応） */}
                  {message.image_urls && message.image_urls.length > 0 && (
                    <div className="flex flex-wrap gap-2 mb-2">
                      {message.image_urls.map((url, idx) => (
                        <div
                          key={idx}
                          className="max-w-[200px] rounded-[12px] overflow-hidden cursor-pointer hover:opacity-90 active:opacity-70 transition-all"
                          onClick={() => setPreviewUrl(url)}
                        >
                          <img src={url} alt="" className="w-full h-auto object-cover" />
                        </div>
                      ))}
                    </div>
                  )}
                  {/* テキスト表示 */}
                  {message.content && (
                    <div className="text-[21px] leading-[1.6] text-textcolor-black mb-2 whitespace-pre-wrap">
                      {message.content}
                    </div>
                  )}
                  <div className="text-[16px] text-gray2-100">{formatDate(message.created_at)}</div>
                </div>

                {/* 子供アイコン */}
                <div className="w-12 h-12 shrink-0">
                  <UserAvatar icon={childIcon} size={48} />
                </div>
              </>
            )}
          </div>
        );
      })}

      {previewUrl && (
        <ChatImageViewer url={previewUrl} onClose={() => setPreviewUrl(undefined)} />
      )}
    </div>
  );
};
